@let vehicle = $vehicle | async;
<!---->
@let users = ($users | async) || [];
<!---->
@let vehicleInsurance = $vehicleInsurance | async;
<!---->
@let vehicleInsuranceFetchedAt = $vehicleInsuranceFetchedAt | async;

<div class="container">
  <mat-card>
    <mat-card-content>
      @if (vehicle) {
      <display-input title="Make" [value]="vehicle.manufacturer" />
      <display-input title="Model" [value]="vehicle.model" />
      <display-input title="Year" [value]="vehicle.year" />
      <display-input title="Color" [value]="vehicle.color" />
      <display-input title="Vin" [value]="vehicle.vin" />
      <display-input
        title="Registration Number"
        [value]="vehicle.registration"
      />
      <display-input title="Volume Capacity (cm³)" [value]="vehicle.volumeCapacity?.toString()" />
      <display-input title="Weight Capacity (kg)" [value]="vehicle.weightCapacity?.toString()" />

      <hr class="my-4" />

      @if (vehicle?.user) {
      <div>
        <display-input
          title="Driver"
          [value]="vehicle?.user?.profile?.firstName + ' ' + vehicle?.user?.profile?.lastName"
        />
      </div>
      <div class="d-flex justify-content-end align-items-center">
        @if (loading) {
        <mat-progress-spinner
          class="me-2"
          mode="indeterminate"
          color="primary"
          diameter="30"
        />
        }
        <button
          (click)="onRemoveDriverClicked(vehicle!)"
          mat-raised-button
          color="primary"
          class="px-4"
          [disabled]="loading"
        >
          Remove Driver
        </button>
      </div>
      } @else {
      <div>
        <mat-form-field class="w-100">
          <mat-label>Available Driver</mat-label>
          <mat-select [(ngModel)]="userId" name="userId">
            @for (user of users; track user) {
            <mat-option [value]="user.id">
              {{ user.profile?.firstName }} {{ user.profile?.lastName }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="d-flex justify-content-end align-items-center">
          @if (loading) {
          <mat-progress-spinner
            class="me-2"
            mode="indeterminate"
            color="primary"
            diameter="30"
          />
          }
          <button
            (click)="onAssignDriverClicked(vehicle?.id!, userId)"
            mat-raised-button
            color="primary"
            class="px-4"
            [disabled]="loading"
          >
            Assign Driver
          </button>
        </div>
      </div>
      }

      <div class="d-flex align-items-center">
        @if (vehicleInsuranceFetchedAt) {
        <button
          [disabled]="!vehicleInsurance"
          (click)="onVehicleInsuranceClicked(vehicle!, vehicleInsurance!, users)"
          mat-flat-button
          type="button"
          class="px-4"
        >
          Insurance
        </button>
        } @else {
        <mat-progress-spinner
          class="me-2"
          mode="indeterminate"
          color="primary"
          diameter="30"
        />
        }
      </div>

      }
      <!---->
      @if (error) {
      <app-alert (close)="error=null" class="mt-3" type="error">
        {{error}}
      </app-alert>
      }
      <!---->
      @if (!vehicle && !($vehiclesFetchedAt | async)) {
      <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner
          class="me-2"
          mode="indeterminate"
          color="primary"
          diameter="30"
        />
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
